import React, { useEffect, useCallback } from "react";
import { ListGroup, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  isModalAtom,
  idxAtom,
  isBoard,
  isContents,
  usersAtom,
} from "../../atoms";
import { motion } from "framer-motion";
import axios from "axios";

function Board() {
  const [, setisidx] = useRecoilState(idxAtom);
  const [, setData] = useRecoilState(isContents);
  const [posts, setPosts] = useRecoilState(isBoard);
  const [, setisMocalopen] = useRecoilState(isModalAtom);
  const authdata = useRecoilValue(usersAtom);

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      로그인이 필요합니다!
    </Tooltip>
  );

  const fetchPosts = useCallback(async () => {
    try {
      const response = await axios.get(`/api/board/list`);
      setPosts(response.data);
    } catch (error) {
      console.error("게시물 목록 요청 중 오류 발생:", error);
    }
  }, [setPosts]);

  const fetchDetailData = useCallback(
    async (b) => {
      try {
        const detailData = await axios.get(`/api/board/detail/${b}`);
        setData(detailData.data);
        const response = await axios.get(`/api/board/list`);
        setPosts(response.data);
      } catch (error) {
        console.error("게시물 세부 정보 요청 중 오류 발생:", error);
      }
    },
    [setData, setPosts]
  );

  useEffect(() => {
    fetchPosts();
  }, [fetchPosts]);

  const handleShow = (a, b) => {
    setisidx(b);
    fetchDetailData(b);
    if (a) setisMocalopen(a);
  };

  function formatDateTime(dateTimeString) {
    const date = new Date(dateTimeString);
    const year = String(date.getFullYear());
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return year + "." + month + "." + day;
  }

  return (
    <div className="container mt-4">
      <h1>게시판</h1>
      <ListGroup className="mt-4">
        <ListGroup.Item
          variant="dark"
          className="align-items-center font-weight-bold"
        >
          <div class="row">
            <div class="col-md-1 text-center border-end">
              <input type="checkbox" />
            </div>
            <div class="col-md-11">
              <div class="row">
                <div class="col-md-1">Index</div>
                <div class="col-md-7">Title</div>
                <div class="col-md-2">Created At</div>
                <div class="col-md-1">Writer</div>
                <div class="col-md-1">Views</div>
              </div>
            </div>
          </div>
        </ListGroup.Item>
        {posts.map(({ idx, title, createdAt, writer, view_count }) => (
          <ListGroup.Item action key={idx} variant="d-flex align-items-center">
            <div class="row">
              <div class="col-md-1 text-center border-end">
                <input type="checkbox" />
              </div>
              <div
                class="col-md-11"
                onClick={() => {
                  handleShow("boardcont", idx);
                }}
              >
                <div class="row">
                  <div class="col-md-1">{idx}</div>
                  <div class="col-md-7">{title}</div>
                  <div class="col-md-2">{formatDateTime(createdAt)}</div>
                  <div class="col-md-1 text-center">{writer}</div>
                  <div class="col-md-1 text-center">{view_count}</div>
                </div>
              </div>
            </div>
          </ListGroup.Item>
        ))}
      </ListGroup>
      <div class="row mt-3">
        <div class="col-md-2 offset-md-10">
          <div class="row">
            <div class="col m-1 p-0">
              <div class="d-grid gap-2">
                {authdata ? (
                  <Button
                    type="button"
                    as={motion.button}
                    whileHover={{ scale: 1.2 }}
                    whileTap={{ scale: 0.9 }}
                    transition={{ type: "spring", stiffness: 400, damping: 17 }}
                    size="sm"
                    variant="secondary"
                  >
                    쓰기
                  </Button>
                ) : (
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip}
                  >
                    <Button
                      variant="secondary"
                      size="sm"
                      onClick={() => {
                        setisMocalopen("login");
                      }}
                    >
                      쓰기
                    </Button>
                  </OverlayTrigger>
                )}
              </div>
            </div>
            <div class="col m-1 p-0">
              <div class="d-grid gap-2">
                <Button
                  type="button"
                  as={motion.button}
                  whileHover={{ scale: 1.2 }}
                  whileTap={{ scale: 0.9 }}
                  transition={{ type: "spring", stiffness: 400, damping: 17 }}
                  size="sm"
                  variant="primary"
                >
                  수정
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Board;
